import React, { useState, useEffect } from "react";
import "./StudentCard.css";
/* Change logo here too */ import logo from "./img/lgo.png";
import { ArrowLeft, Delete, Download } from "react-feather";
import html2canvas from "html2canvas";
import defaultIcon from "./carte etudiant/img/icon.jpg";

const StudentCard = ({ student, onDelete }) => {
  const getStudentImage = (name) => {
    const image = localStorage.getItem(`studentImage_${name}`);
    if (image) {
      return image;
    }
    // Return default icon - dynamic require causes webpack build issues
    return defaultIcon;
  };

  const handleDownload = () => {
    const cardElement = document.querySelector(".card");
    html2canvas(cardElement, {
      width: 550,
      backgroundColor: 'black',
      scale: 1
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = `${student.Names.replace(/\s+/g, "_")}_Student_Card.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  return (
    <div className="GOMA">
      <div className="card">
        <div className="heading">
          <img src={logo} alt="University Logo" className="logo" />
          <div className="university-info">
{/*T-CARD*/}  <h3 style={{textTransform: "uppercase"}}>Institut Supérieur Pédagogique et Technique - GOMA</h3>
            <p style={{ textTransform: "uppercase", fontWeight: "bolder" }}>
            Créez, travailler et partager
              
            </p>
          </div>
        </div>
        <div className="student-section">
          <h3>STUDENT CARD</h3>
          <div className="student-info">
            <div className="photo-container">
              <img
                src={getStudentImage(student.Names)}
                alt={`Student ${student.Names}`}
                className="photo"
              />
            </div>
            <div className="details">
              <p><strong>Names:</strong> {student.Names}</p>
              <p><strong>Faculty:</strong> {student.Faculty}</p>
              <p><strong>Department:</strong> {student.Department}</p>
              <p>
                <strong>Class:</strong> {student.Class}, <strong>Matricule:</strong> {student.Matricule}
              </p>
              <p><strong>Academic Year:</strong> {student["Academic year"]}</p>
            </div>
          </div>
        </div>
        <div className="footer">
          <strong style={{ marginLeft: 68, fontSize: 11 }}>
{/* Contact */} Web: www.isptgoma.net | E-mail: infi@isptgoma.net
          </strong>
        </div>
      </div>
      <div className="crud">
        <button className="download-button" onClick={() => onDelete(student)}>
          Supprimer
        </button>
        <button className="download-button" onClick={handleDownload}>
          Telecharger <Download style={{margin: "1px 0 -2px 10px"}} size={15}/>
        </button>
      </div>
    </div>
  );
};

const Gen = () => {
  const [students, setStudents] = useState([]);
  const [formData, setFormData] = useState({
    Names: "",
    Faculty: "",
    Department: "",
    Class: "",
    Matricule: "",
    "Academic year": "",
    image: null,
  });
  const [selectedStudent, setSelectedStudent] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem("students");
    if (storedData) {
      setStudents(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("students", JSON.stringify(students));
  }, [students]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleAddStudent = () => {
    if (
      formData.Names &&
      formData.Faculty &&
      formData.Department &&
      formData.Class &&
      formData.Matricule &&
      formData["Academic year"]
    ) {
      const newStudent = { ...formData };
      setStudents((prevStudents) => [newStudent, ...prevStudents]);

      if (formData.image) {
        const reader = new FileReader();
        reader.onloadend = () => {
          localStorage.setItem(`studentImage_${formData.Names}`, reader.result);
        };
        reader.readAsDataURL(formData.image);
      }

      setFormData({
        Names: "",
        Faculty: "",
        Department: "",
        Class: "",
        Matricule: "",
        "Academic year": "",
        image: null,
      });

      const container = document.querySelector(".cards-container");
      if (container) {
        container.scrollTop = 0;
      }
    } else {
      alert("Please fill out all fields.");
    }
  };

  const handleDeleteStudent = (studentToDelete) => {
    setStudents((prevStudents) =>
      prevStudents.filter((student) => student !== studentToDelete)
    );
    if (selectedStudent === studentToDelete) {
      setSelectedStudent(null);
    }
  };

  const handleViewStudent = (student) => {
    setSelectedStudent(student);
  };

  return (
    <div className="GOMA">
      <div className="stu-card">
        <div className="card-form">
          <img src={logo} className="form-logo" alt="Logo" />

          <div className="card-data">
            <input
              className="cinput"
              type="text"
              name="Names"
              placeholder="Names"
              value={formData.Names}
              onChange={handleChange}
            />
            <input
              className="cinput"
              type="text"
              name="Faculty"
              placeholder="Faculty"
              value={formData.Faculty}
              onChange={handleChange}
            />
            <input
              className="cinput"
              type="text"
              name="Department"
              placeholder="Department"
              value={formData.Department}
              onChange={handleChange}
            />
            <input
              className="cinput"
              type="text"
              name="Class"
              placeholder="Class"
              value={formData.Class}
              onChange={handleChange}
            />
            <input
              className="cinput"
              type="text"
              name="Matricule"
              placeholder="Matricule"
              value={formData.Matricule}
              onChange={handleChange}
            />
            <input
              className="cinput"
              type="text"
              name="Academic year"
              placeholder="Academic Year"
              value={formData["Academic year"]}
              onChange={handleChange}
            />
            <input
              className="cinput"
              type="file"
              name="image"
              accept="image/*"
              onChange={handleChange}
            />
            <button className="download-button" onClick={handleAddStudent}>Générer la Carte</button>
          </div>
        </div>

        <div className="view-button">
    <button onClick={() => setSelectedStudent(null)}>
      {selectedStudent === null ? (
        <span></span>
      ) : (
        <span>
          <ArrowLeft size={12} /> <b> Retour </b>
        </span>
      )}
    </button>
  </div>

  {selectedStudent === null ? (
    <div>
      <h4 className="title-cards">Cartes disponible</h4>
      <div className="cards-container">
        {students.length === 0 ? (
          <p className="no-cards-message">Pas de carte disponible</p>
        ) : (
          students.map((student, index) => (
            <div className="card-item" key={index}>
              <button
                className="stu-button"
                onClick={() => handleViewStudent(student)}
              >
                {student.Names}
              </button>
              <button
                id="del"
                className="crud-button"
                onClick={() => handleDeleteStudent(student)}
              >
                <Delete size={18} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  ) : (
    <StudentCard student={selectedStudent} onDelete={handleDeleteStudent} />
  )}

      </div>
    </div>
  );
};

export default Gen;
